/** Builds the request-form payload with page attribution (browser-only fields read lazily). */
type Base = {
  kind: "demo" | "contact" | "partner";
  fullName: string;
  email: string;
  company: string;
  phone: string;
  country: string;
  industry: string;
  message: string;
  planSlug: string;
  website: string;
  locale: string;
};

const UTM = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"] as const;
const UTM_KEYS = { utm_source: "utmSource", utm_medium: "utmMedium", utm_campaign: "utmCampaign", utm_term: "utmTerm", utm_content: "utmContent" } as const;

export function buildRequestPayload<T extends Base>(base: T, loc: Location | undefined = typeof window !== "undefined" ? window.location : undefined, ref: string = typeof document !== "undefined" ? document.referrer : "") {
  const out: Record<string, string> = {};
  for (const [k, v] of Object.entries(base)) out[k] = typeof v === "string" ? v.trim() : v;
  out["email"] = (out["email"] ?? "").toLowerCase();
  if (loc) {
    out["pagePath"] = (loc.pathname + loc.search).slice(0, 300);
    out["pageUrl"] = (loc.origin + loc.pathname).slice(0, 1000);
    const params = new URLSearchParams(loc.search);
    for (const key of UTM) {
      const value = params.get(key)?.trim();
      if (value) out[UTM_KEYS[key]] = value.slice(0, 200);
    }
  }
  if (/^https?:\/\//.test(ref)) out["referrer"] = ref.slice(0, 1000);
  return out as T & Record<string, string>;
}
